import React from 'react';
import './index.scss';
import { NavLink } from 'react-router-dom';
import BetaTag from '$/components/global/betaTag';

interface IHeadingTabProps {
  title: string;
  link: string;
  active?: boolean;
  exact?: boolean;
  includeBetaTag?: boolean;
  end?: boolean;
}

const HeadingTab: React.FC<IHeadingTabProps> = props => {
  const { title, link, includeBetaTag, end = true } = props;
  return (
    <NavLink to={link} end={end} className={({ isActive }) => 'heading_tab' + (isActive ? ' active' : '')}>
      {title} {includeBetaTag ? <BetaTag /> : ''}
    </NavLink>
  );
};

export default HeadingTab;
